import React from "react";

const UpArrowIcon = () => {
  return (
    <svg
      className="button__arrow"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9.4 9.7"
      width="10"
      height="10"
    >
      <path
        fill="#ffffff"
        className="button__arrow__path"
        d="M3.8 2.8c-.3.3-.7.6-1 .9-.4.4-.9.8-1.3 1.3-.3.2-.6.3-.9.2-.4-.1-.5-.3-.6-.7 0-.3.1-.5.2-.6.8-.8 1.6-1.6 2.4-2.3.5-.4.9-.9 1.4-1.3.3-.3.8-.3 1.1 0C6.5 1.4 7.8 2.6 9 3.8c.2.2.4.5.3.8 0 .3-.2.5-.6.6-.3.1-.5 0-.8-.2-.7-.7-1.5-1.4-2.3-2.2 0 0-.1-.1-.2-.1v6.2c0 .6-.6 1-1.2.8-.2-.2-.4-.5-.4-.8V2.8"
      />
    </svg>
  );
};

export default UpArrowIcon;
